module.exports = "/_next/static/images/cristina-vulpe-26fda29c68488a9156c57b7befc027f8.webp";